<template>
  <div class="top">
    <!-- 左侧：Logo 区域 -->
    <div class="top-button is-left">
      <logo class="top-logo"></logo>
    </div>

    <!-- 中间：顶部菜单 -->
    <h1 class="top-title">
      <topMenu></topMenu>
    </h1>

    <!-- 右侧：操作区 -->
    <div class="top-button is-right">
      <!-- 首页按钮 -->
      <el-tooltip class="item top-tooltip" effect="dark" content="返回首页" placement="bottom">
        <span class="top-item top-icon-btn" @click="toHome" role="button" tabindex="0" @keyup.enter="toHome">
          <i class="el-icon-menu"></i>
        </span>
      </el-tooltip>

      <!-- 主题色 -->
      <el-tooltip class="item top-tooltip" effect="dark" content="主题色" placement="bottom">
        <span class="top-item top-color-wrap">
          <top-color></top-color>
        </span>
      </el-tooltip>

      <!-- 分隔线 -->
      <span class="top-divider" aria-hidden="true"></span>

      <!-- 公司名称（桌面端显示） -->
      <span v-if="company" class="top-company desktop-only" :title="company">{{ company }}</span>

      <!-- 用户下拉菜单 -->
      <el-dropdown class="top-user-dropdown" trigger="click" @command="handleUserCommand">
        <span class="top-user-trigger" role="button" tabindex="0">
          <img v-if="null != userInfo && userInfo.avatar" class="top-userImg" :src="userInfo.avatar" alt="用户头像">
          <span v-else class="top-userImg top-userImg--default" aria-hidden="true">
            <i class="el-icon-user-solid"></i>
          </span>
          <span v-if="userInfo && userInfo.username" class="top-user-name desktop-only">{{ userInfo.username }}</span>
          <i class="el-icon-arrow-down top-user-arrow"></i>
        </span>
        <el-dropdown-menu slot="dropdown" class="top-dropdown-menu">
          <div class="top-dropdown-header" v-if="userInfo">
            <div class="top-dropdown-name">{{ userInfo.realName || '用户' }}</div>
            <div v-if="company" class="top-dropdown-company" :title="company">{{ company }}</div>
          </div>
          <el-dropdown-item command="password" icon="el-icon-key">修改密码</el-dropdown-item>
          <el-dropdown-item divided command="logout" icon="el-icon-switch-button">退出系统</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <!-- 修改密码弹窗 -->
    <el-dialog :visible.sync="changePasswordVisible" width="460px" :close-on-click-modal="false" custom-class="password-dialog"
      @closed="resetPasswordForm">
      <div slot="title" class="password-dialog__title">
        <span class="password-dialog__title-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        </span>
        <span class="password-dialog__title-text">修改密码</span>
        <span class="password-dialog__title-sub">定期修改密码可以提升账号安全性</span>
      </div>
      <el-form ref="passwordForm" :model="passwordForm" :rules="passwordRules" label-width="90px" class="password-form">
        <el-form-item label="原密码" prop="oldPassword">
          <el-input v-model="passwordForm.oldPassword" :type="oldPwdVisible ? 'text' : 'password'" placeholder="请输入原密码"
            autocomplete="new-password" maxlength="32">
            <span slot="suffix" class="password-suffix">
              <i v-if="passwordForm.oldPassword" class="password-suffix__clear el-input__icon el-input__icon-clear el-icon-circle-close"
                @click="passwordForm.oldPassword = ''" @mousedown.prevent title="清空"></i>
              <span class="password-eye" :class="{ 'is-active': oldPwdVisible }" @click="oldPwdVisible = !oldPwdVisible"
                role="button" tabindex="0" @keyup.enter="oldPwdVisible = !oldPwdVisible" :title="oldPwdVisible ? '隐藏密码' : '查看密码'">
                <svg v-if="oldPwdVisible" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor"
                  stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
                <svg v-else viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-7 0-11-7-11-7a19.81 19.81 0 0 1 4.22-5.36" />
                  <path d="M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 7 11 7a19.66 19.66 0 0 1-3.17 4.19" />
                  <path d="M14.12 14.12A3 3 0 1 1 9.88 9.88" />
                  <line x1="1" y1="1" x2="23" y2="23" />
                </svg>
              </span>
            </span>
          </el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="passwordForm.newPassword" :type="newPwdVisible ? 'text' : 'password'" placeholder="请输入新密码"
            autocomplete="new-password" maxlength="32">
            <span slot="suffix" class="password-suffix">
              <i v-if="passwordForm.newPassword" class="password-suffix__clear el-input__icon el-input__icon-clear el-icon-circle-close"
                @click="passwordForm.newPassword = ''" @mousedown.prevent title="清空"></i>
              <span class="password-eye" :class="{ 'is-active': newPwdVisible }" @click="newPwdVisible = !newPwdVisible"
                role="button" tabindex="0" @keyup.enter="newPwdVisible = !newPwdVisible" :title="newPwdVisible ? '隐藏密码' : '查看密码'">
                <svg v-if="newPwdVisible" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor"
                  stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
                <svg v-else viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-7 0-11-7-11-7a19.81 19.81 0 0 1 4.22-5.36" />
                  <path d="M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 7 11 7a19.66 19.66 0 0 1-3.17 4.19" />
                  <path d="M14.12 14.12A3 3 0 1 1 9.88 9.88" />
                  <line x1="1" y1="1" x2="23" y2="23" />
                </svg>
              </span>
            </span>
          </el-input>
          <!-- 密码强度提示 -->
          <div v-if="passwordForm.newPassword" class="password-strength" :class="`is-${newPwdStrength.level}`">
            <span class="password-strength__label">强度</span>
            <div class="password-strength__bars">
              <span class="password-strength__bar"></span>
              <span class="password-strength__bar"></span>
              <span class="password-strength__bar"></span>
            </div>
            <span class="password-strength__text">{{ newPwdStrength.text }}</span>
          </div>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="passwordForm.confirmPassword" :type="confirmPwdVisible ? 'text' : 'password'" placeholder="请再次输入新密码"
            autocomplete="new-password" maxlength="32">
            <span slot="suffix" class="password-suffix">
              <i v-if="passwordForm.confirmPassword" class="password-suffix__clear el-input__icon el-input__icon-clear el-icon-circle-close"
                @click="passwordForm.confirmPassword = ''" @mousedown.prevent title="清空"></i>
              <span class="password-eye" :class="{ 'is-active': confirmPwdVisible }"
                @click="confirmPwdVisible = !confirmPwdVisible" role="button" tabindex="0"
                @keyup.enter="confirmPwdVisible = !confirmPwdVisible" :title="confirmPwdVisible ? '隐藏密码' : '查看密码'">
                <svg v-if="confirmPwdVisible" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor"
                  stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
                <svg v-else viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-7 0-11-7-11-7a19.81 19.81 0 0 1 4.22-5.36" />
                  <path d="M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 7 11 7a19.66 19.66 0 0 1-3.17 4.19" />
                  <path d="M14.12 14.12A3 3 0 1 1 9.88 9.88" />
                  <line x1="1" y1="1" x2="23" y2="23" />
                </svg>
              </span>
            </span>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="password-dialog__footer">
        <el-button @click="changePasswordVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitChangePassword" :loading="passwordLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { setCompany, getCompany } from "@/util/auth";
import { findUserId, findCompany } from "@/api/salesCloud/company";
import { changePassword } from "@/api/login/login";
import { fullscreenToggel, listenfullscreen } from "@/util/util";
import topLock from "./top-lock";
import topMenu from "./top-menu";
import topBreadcrumb from "./top-breadcrumb";
import topColor from "./top-color";
import topTheme from "./top-theme";
import topLogs from "./top-logs";
import logo from "../logo";
export default {
  components: {
    topLock,
    topMenu,
    topBreadcrumb,
    topColor,
    topTheme,
    topLogs,
    logo
  },
  name: "top",
  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.passwordForm.newPassword) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };
    return {
      company: "",
      changePasswordVisible: false,
      passwordLoading: false,
      oldPwdVisible: false,
      newPwdVisible: false,
      confirmPwdVisible: false,
      passwordForm: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
      },
      passwordRules: {
        oldPassword: [
          { required: true, message: "请输入原密码", trigger: "blur" }
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, message: "密码长度不能少于6位", trigger: "blur" }
        ],
        confirmPassword: [
          { required: true, message: "请再次输入新密码", trigger: "blur" },
          { validator: validateConfirmPassword, trigger: "blur" }
        ]
      }
    };
  },
  filters: {},
  created() {
    findUserId().then(res => {
      let data = JSON.parse(res.data);
      let userId = data.id;
      findCompany(userId).then(res => {
        let company = res.data;
        setCompany(company);
        let a = getCompany();
        this.company = a;
      });
    });
  },
  mounted() {
    listenfullscreen(this.setScreen);
  },
  computed: {
    newPwdStrength() {
      const pwd = this.passwordForm.newPassword || "";
      if (!pwd) return { level: 0, text: "" };
      let score = 0;
      if (pwd.length >= 6) score += 1;
      if (pwd.length >= 10) score += 1;
      if (/[A-Z]/.test(pwd) && /[a-z]/.test(pwd)) score += 1;
      if (/\d/.test(pwd)) score += 1;
      if (/[^\w\s]/.test(pwd)) score += 1;
      if (pwd.length < 6) return { level: 1, text: "弱" };
      if (score <= 2) return { level: 1, text: "弱" };
      if (score <= 3) return { level: 2, text: "中" };
      return { level: 3, text: "强" };
    },
    ...mapGetters([
      "userInfo",
      "isFullScren",
      "tagWel",
      "tagList",
      "isCollapse",
      "tag",
      "logsLen",
      "logsFlag"
    ])
  },
  methods: {
    toHome() {
      this.$router.push({ path: "/" });
    },
    handleScreen() {
      fullscreenToggel();
    },
    showCollapse() {
      this.$store.commit("SET_COLLAPSE");
    },
    setScreen() {
      this.$store.commit("SET_FULLSCREN");
    },
    logout() {
      this.$confirm("是否退出系统, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store.dispatch("LogOut").then(() => {
          this.$router.push({ path: "/login" });
        });
      });
    },
    handleUserCommand(command) {
      switch (command) {
        case "password":
          this.changePasswordVisible = true;
          break;
        case "logout":
          this.logout();
          break;
        default:
          break;
      }
    },
    submitChangePassword() {
      this.$refs.passwordForm.validate(valid => {
        if (!valid) return;
        this.passwordLoading = true;
        changePassword({
          oldPassword: this.passwordForm.oldPassword,
          newPassword: this.passwordForm.newPassword
        }).then(res => {
          // 有响应体说明是业务错误（HTTP 200 但含错误信息），无响应体才是成功
          if (res && res.code == '200') {
            this.$message.success("密码修改成功，请重新登录");
            this.changePasswordVisible = false;
            this.$store.dispatch("LogOut").then(() => {
              this.$router.push({ path: "/login" });
            });
          } else {
            this.$message.error("密码修改失败，请检查原密码是否正确");
          }

        }).catch(() => {
          this.$message.error("密码修改失败，请检查原密码是否正确");
        }).finally(() => {
          this.passwordLoading = false;
        });
      });
    },
    resetPasswordForm() {
      this.passwordForm = {
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
      };
      this.oldPwdVisible = false;
      this.newPwdVisible = false;
      this.confirmPwdVisible = false;
      if (this.$refs.passwordForm) {
        this.$refs.passwordForm.resetFields();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.top {
  align-items: center;
  border-bottom: 1px solid $color-border-light;
  color: $color-text-regular;
  display: flex;
  font-size: $font-size-lg;
  height: $header-height;
  line-height: 1;
  padding: 0 $spacing-md;
  white-space: nowrap;
}

.top-title {
  padding-left: $spacing-xl;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: inherit;
  font-weight: 400;
  flex: 1;
}

.top-userImg {
  margin: 0;
  padding: 2px;
  width: 32px;
  height: 32px;
  border-radius: 100%;
  box-sizing: border-box;
  border: 1px solid $color-border-base;
  background: $color-bg-container;
  transition: border-color $transition-base, box-shadow $transition-base;
  vertical-align: middle;

  &--default {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: $color-bg-hover;
    color: $color-text-secondary;
    font-size: 16px;
  }
}

.top-button {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.top-logo {
  flex-shrink: 0;

  ::v-deep .logo {
    width: auto;
    height: $header-height;
    padding: 0 $spacing-sm 0 0;
    justify-content: flex-start;
    line-height: $header-height;
  }

  ::v-deep .logo_title {
    font-size: $font-size-lg;
    color: $color-text-primary;
  }

  ::v-deep .logo_subtitle {
    font-size: $font-size-md;
    color: $color-text-secondary;
    font-weight: 500;
    margin-left: $spacing-xs;
  }

  ::v-deep img {
    margin-right: $spacing-sm;
  }
}

.top-item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: $spacing-xs;
}

.top-tooltip {
  display: inline-flex;
  align-items: center;
}

.top-icon-btn {
  width: 36px;
  height: 36px;
  border-radius: $border-radius-base;
  color: $color-text-regular;
  font-size: 18px;
  cursor: pointer;
  transition: background-color $transition-base, color $transition-base, transform $transition-base;

  &:hover {
    background: $color-bg-hover;
    color: $color-primary;
  }

  &:active {
    transform: scale(0.96);
  }

  &:focus {
    outline: none;
  }
}

.top-color-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 $spacing-xs;
  border-radius: $border-radius-base;
  transition: background-color $transition-base;

  &:hover {
    background: $color-bg-hover;
  }

  ::v-deep .theme-picker {
    line-height: 1;
  }

  ::v-deep .el-color-picker__trigger {
    vertical-align: middle;
  }
}

.top-divider {
  display: inline-block;
  width: 1px;
  height: 18px;
  margin: 0 $spacing-sm;
  background: $color-border-light;
}

.top-company {
  max-width: 200px;
  margin-right: $spacing-sm;
  font-size: $font-size-md;
  color: $color-text-regular;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.top-user-dropdown {
  margin-left: $spacing-xs;

  ::v-deep .top-user-trigger {
    display: inline-flex;
    align-items: center;
    height: 40px;
    padding: 0 $spacing-sm;
    border-radius: 20px;
    cursor: pointer;
    transition: background-color $transition-base, box-shadow $transition-base;

    &:hover {
      background: $color-bg-hover;

      .top-userImg {
        border-color: $color-primary;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
      }

      .top-user-arrow {
        color: $color-primary;
      }
    }

    &:focus {
      outline: none;
    }
  }
}

.top-user-trigger {
  display: inline-flex;
  align-items: center;
  height: 40px;
  padding: 0 $spacing-sm;
  border-radius: 20px;
  cursor: pointer;
  transition: background-color $transition-base, box-shadow $transition-base;

  &:hover {
    background: $color-bg-hover;

    .top-userImg {
      border-color: $color-primary;
      box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
    }

    .top-user-arrow {
      color: $color-primary;
    }
  }

  &:focus {
    outline: none;
  }
}

.top-user-name {
  margin: 0 $spacing-xs;
  font-size: $font-size-base;
  color: $color-text-primary;
  font-weight: 500;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.top-user-arrow {
  font-size: 12px;
  color: $color-text-secondary;
  transition: color $transition-base, transform $transition-base;
}

.desktop-only {
  display: inline;
}

@include mobile {
  .top {
    height: $header-height-mobile;
    padding: 0 $spacing-sm;
  }

  .top-title {
    display: none;
  }

  .desktop-only {
    display: none !important;
  }

  .top-divider {
    display: none;
  }

  .top-company {
    display: none;
  }

  .top-user-trigger {
    padding: 0 $spacing-xs;
  }

  .top-user-dropdown {
    margin-left: 0;
  }

  .top-icon-btn {
    width: 32px;
    height: 32px;
    font-size: 16px;
  }

  .top-color-wrap {
    height: 32px;
  }

  .top-userImg {
    width: 28px;
    height: 28px;
  }
}

// ============================
// 修改密码弹窗
// ============================
.password-dialog__title {
  display: flex;
  align-items: center;
  line-height: 1.2;
  padding: 4px 0;

  &-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    margin-right: $spacing-sm;
    border-radius: $border-radius-md;
    background: linear-gradient(135deg, rgba(64, 158, 255, 0.12), rgba(64, 158, 255, 0.04));
    color: $color-primary;
  }

  &-text {
    font-size: 16px;
    font-weight: 600;
    color: $color-text-primary;
  }

  &-sub {
    margin-left: $spacing-sm;
    padding-left: $spacing-sm;
    font-size: 12px;
    font-weight: 400;
    color: $color-text-secondary;
    border-left: 1px solid $color-border-light;
  }
}

.password-form {
  padding: $spacing-sm $spacing-xs 0;

  ::v-deep .el-form-item__label {
    color: $color-text-regular;
    font-size: 13px;
  }

  ::v-deep .el-input__inner {
    padding-right: 78px;
    transition: border-color $transition-base, box-shadow $transition-base;
  }

  ::v-deep .el-input__suffix {
    right: 8px;
  }
}

// 小眼睛切换
.password-suffix {
  display: inline-flex;
  align-items: center;
  height: 100%;
  margin-right: -6px;

  &__clear {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    margin-right: 2px;
    font-size: 16px;
    color: $color-text-secondary;
    cursor: pointer;
    border-radius: 50%;
    transition: color $transition-base, background-color $transition-base;

    &:hover {
      color: $color-text-regular;
      background: $color-bg-hover;
    }
  }
}

.password-eye {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  color: $color-text-secondary;
  cursor: pointer;
  border-radius: $border-radius-sm;
  transition: color $transition-base, background-color $transition-base;

  &:hover {
    color: $color-primary;
    background: $color-bg-hover;
  }

  &.is-active {
    color: $color-primary;
  }
}

// 密码强度条
.password-strength {
  display: flex;
  align-items: center;
  margin-top: $spacing-xs;
  font-size: 12px;
  line-height: 1;

  &__label {
    margin-right: $spacing-sm;
    color: $color-text-secondary;
  }

  &__bars {
    display: inline-flex;
    align-items: center;
    width: 80px;
    height: 4px;
  }

  &__bar {
    flex: 1;
    height: 100%;
    margin-right: 3px;
    background: $color-border-lighter;
    border-radius: 2px;
    transition: background-color $transition-base;

    &:last-child {
      margin-right: 0;
    }
  }

  &__text {
    margin-left: $spacing-sm;
    color: $color-text-secondary;
  }

  &.is-1 {
    .password-strength__bar:nth-child(1) {
      background: $color-danger;
    }
    .password-strength__text {
      color: $color-danger;
    }
  }

  &.is-2 {
    .password-strength__bar:nth-child(1),
    .password-strength__bar:nth-child(2) {
      background: $color-warning;
    }
    .password-strength__text {
      color: $color-warning;
    }
  }

  &.is-3 {
    .password-strength__bar {
      background: $color-success;
    }
    .password-strength__text {
      color: $color-success;
    }
  }
}
</style>

<style lang="scss">
.top-dropdown-menu {
  padding: 0 !important;
  min-width: 180px;
  border-radius: $border-radius-md !important;
  box-shadow: $shadow-dropdown;

  .el-dropdown-menu__item {
    padding: 0 $spacing-md !important;
    line-height: 40px;
    font-size: $font-size-base;
    color: $color-text-primary;
    transition: background-color $transition-base, color $transition-base;

    i {
      margin-right: $spacing-sm;
      color: $color-text-secondary;
      transition: color $transition-base;
    }

    &:hover {
      background: $color-bg-hover;
      color: $color-primary;

      i {
        color: $color-primary;
      }
    }

    &.is-divided {
      border-top: 1px solid $color-border-lighter;
    }
  }
}

.top-dropdown-header {
  padding: $spacing-sm $spacing-md;
  border-bottom: 1px solid $color-border-lighter;
  background: $color-bg-hover;
  border-top-left-radius: $border-radius-md;
  border-top-right-radius: $border-radius-md;

  .top-dropdown-name {
    font-size: $font-size-md;
    font-weight: 600;
    color: $color-text-primary;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .top-dropdown-company {
    margin-top: 2px;
    font-size: $font-size-xs;
    color: $color-text-secondary;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

// ============================
// 修改密码弹窗（全局）
// ============================
.password-dialog {
  border-radius: $border-radius-md !important;
  overflow: hidden;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12) !important;

  .el-dialog__header {
    padding: $spacing-md $spacing-lg !important;
    border-bottom: 1px solid $color-border-lighter;
    background: linear-gradient(180deg, #fafbfc 0%, #ffffff 100%);
  }

  .el-dialog__headerbtn {
    top: $spacing-md !important;
    right: $spacing-md !important;
    width: 28px;
    height: 28px;

    .el-dialog__close {
      color: $color-text-secondary;
      transition: color $transition-base, background-color $transition-base;
    }

    &:hover .el-dialog__close {
      color: $color-primary;
      background: $color-bg-hover;
      border-radius: 50%;
    }
  }

  .el-dialog__body {
    padding: $spacing-lg $spacing-lg $spacing-sm !important;
    background: #fff;
  }

  .el-dialog__footer {
    padding: $spacing-md $spacing-lg $spacing-lg !important;
    border-top: 1px solid $color-border-lighter;
    background: $color-bg-hover;
  }
}

.password-dialog__footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: $spacing-sm;

  .el-button {
    min-width: 88px;
    height: 34px;
    padding: 0 $spacing-md;
    font-size: 13px;
    border-radius: $border-radius-base;
    transition: all $transition-base;

    & + .el-button {
      margin-left: 0;
    }
  }

  .el-button--default {
    border-color: $color-border-base;
    color: $color-text-regular;

    &:hover {
      color: $color-primary;
      border-color: $color-primary-light;
      background: rgba(64, 158, 255, 0.06);
    }
  }

  .el-button--primary {
    background: linear-gradient(135deg, $color-primary 0%, $color-primary-light 100%);
    border-color: $color-primary;
    box-shadow: 0 2px 6px rgba(64, 158, 255, 0.25);

    &:hover {
      background: linear-gradient(135deg, $color-primary-light 0%, $color-primary 100%);
      box-shadow: 0 4px 10px rgba(64, 158, 255, 0.35);
      transform: translateY(-1px);
    }

    &:active {
      transform: translateY(0);
    }
  }
}
</style>
